var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "container-fluid" },
      [
        _c("BarreFiltres", {
          ref: "barreFiltres",
          attrs: { filtres: _vm.filtres },
          on: {
            "appliquer-filtre": function($event) {
              return _vm.appliquerFiltre($event)
            }
          }
        }),
        _c("BarreActions", {
          ref: "barreActions",
          attrs: { actions: _vm.actions },
          on: {
            "appliquer-action": function($event) {
              return _vm.executerAction($event)
            }
          }
        }),
        _c("ModalImportMercuComplementaire", {
          ref: "modalImportMercuComplementaire",
          attrs: {
            listeFournisseurs: _vm.listeFournisseurs,
            optionsFamilles: _vm.optionsFamilles
          }
        }),
        _c("ModalAjoutProduitComplementaire", {
          ref: "modalAjoutProduitComplementaire",
          attrs: {
            produitComplementaire: _vm.produitSelectionne,
            paramModale: _vm.paramModale,
            optionsUC: _vm.optionsUC
          },
          on: {
            "produit-modifie": function($event) {
              return _vm.majListeProduit($event)
            }
          }
        }),
        _c("div", { staticClass: "card table-scroll height-responsive-0b" }, [
          _c("div", { staticClass: "card-header flex-center-space-between" }, [
            _c("div", { staticClass: "flex-start" }, [
              _c("span", [_vm._v(_vm._s(_vm.fournisseurSelectionne.nom))])
            ]),
            _c("span", [
              _vm._v(
                " " +
                  _vm._s(_vm.familleSelectionnee.texte) +
                  " (Prix affichés en base 100) "
              )
            ]),
            _c("span", [_vm._v(" " + _vm._s(_vm.periodeTarif) + " ")])
          ]),
          _c(
            "table",
            {
              staticClass:
                "table table-bordered table-sm text-center table-header-secondary"
            },
            [
              _vm._m(0),
              _c("thead", [
                _c("th", { staticClass: "aligner-gauche" }, [
                  _vm._v("Ingrédient")
                ]),
                _c(
                  "th",
                  {
                    staticClass: "aligner-gauche watchMe",
                    on: {
                      click: function($event) {
                        return _vm.trierListe("designation")
                      }
                    }
                  },
                  [
                    _vm._v("Désignation"),
                    _vm.afficheIconeTri("designation")
                      ? _c("i", { class: _vm.iconeSensTri })
                      : _vm._e()
                  ]
                ),
                _c(
                  "th",
                  {
                    staticClass: "watchMe",
                    on: {
                      click: function($event) {
                        return _vm.trierListe("marque")
                      }
                    }
                  },
                  [
                    _vm._v("Marque"),
                    _vm.afficheIconeTri("marque")
                      ? _c("i", { class: _vm.iconeSensTri })
                      : _vm._e()
                  ]
                ),
                _c(
                  "th",
                  {
                    staticClass: "watchMe",
                    on: {
                      click: function($event) {
                        return _vm.trierListe("reference")
                      }
                    }
                  },
                  [
                    _vm._v("Référence"),
                    _vm.afficheIconeTri("reference")
                      ? _c("i", { class: _vm.iconeSensTri })
                      : _vm._e()
                  ]
                ),
                _c(
                  "th",
                  {
                    staticClass: "watchMe",
                    on: {
                      click: function($event) {
                        return _vm.trierListe("prix", true)
                      }
                    }
                  },
                  [
                    _vm._v("P.U."),
                    _vm.afficheIconeTri("prix")
                      ? _c("i", { class: _vm.iconeSensTri })
                      : _vm._e()
                  ]
                ),
                _c("th", [_vm._v("PCB")]),
                _c("th", [_vm._v("TVA")]),
                _c("th", [_vm._v("Allergènes")])
              ])
            ]
          ),
          _c("div", { staticClass: "table-body" }, [
            _c(
              "table",
              { staticClass: "table table-bordered table-sm text-center" },
              [
                _vm._m(1),
                _c(
                  "tbody",
                  _vm._l(_vm.produitsComplementaire, function(
                    produits,
                    iProduit
                  ) {
                    return _c(
                      "tr",
                      {
                        key: iProduit,
                        class: [
                          {
                            "ligne-selectionnee":
                              produits.produitId === _vm.idProduitSelectionne &&
                              produits.tarifId === _vm.idTarifSelectionne
                          }
                        ],
                        on: {
                          click: function($event) {
                            return _vm.selectionnerProduit(produits)
                          }
                        }
                      },
                      [
                        [
                          !produits.ingredient
                            ? _c("td", { staticClass: "aligner-gauche" }, [
                                _c("em", { staticClass: "text-warning" }, [
                                  _vm._v("Pas d'ingrédient")
                                ])
                              ])
                            : _c("td", { staticClass: "aligner-gauche" }, [
                                _vm._v(" " + _vm._s(produits.ingredient) + " ")
                              ]),
                          _c("td", { staticClass: "aligner-gauche" }, [
                            _vm._v(_vm._s(produits.designation))
                          ]),
                          _c("td", [_vm._v(_vm._s(produits.marque))]),
                          _c("td", [_vm._v(_vm._s(produits.reference))]),
                          _c("td", [
                            _vm._v(_vm._s(produits.prixUnitaireHT) + " €")
                          ]),
                          _c("td", [
                            _vm._v(
                              _vm._s(produits.pcb) + " " + _vm._s(produits.uc)
                            )
                          ]),
                          _c("td", [_vm._v(_vm._s(produits.tauxTVA) + " ")]),
                          _c("td", [
                            _vm._v(
                              " " + _vm._s(_vm.formatAllergene(produits)) + " "
                            ),
                            _vm.sansAllergene(produits)
                              ? _c("em", { staticClass: "error ml-2" }, [
                                  _c("i", {
                                    staticClass:
                                      "fas fa-exclamation-triangle ligne-modifiee"
                                  }),
                                  _vm._v(" Aucun allergène sélectionné ")
                                ])
                              : _vm._e()
                          ])
                        ]
                      ],
                      2
                    )
                  }),
                  0
                )
              ]
            )
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "180" } }),
      _c("col"),
      _c("col", { attrs: { width: "180" } }),
      _c("col", { attrs: { width: "100" } }),
      _c("col", { attrs: { width: "100" } }),
      _c("col", { attrs: { width: "80" } }),
      _c("col", { attrs: { width: "80" } }),
      _c("col", { attrs: { width: "200" } }),
      _c("col", { attrs: { width: "50" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "180" } }),
      _c("col"),
      _c("col", { attrs: { width: "180" } }),
      _c("col", { attrs: { width: "100" } }),
      _c("col", { attrs: { width: "100" } }),
      _c("col", { attrs: { width: "80" } }),
      _c("col", { attrs: { width: "80" } }),
      _c("col", { attrs: { width: "200" } }),
      _c("col", { attrs: { width: "45" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }